import cx from 'classnames';
import { Link } from 'react-router-dom';

import {
	IconAccountAttention,
	IconGhost,
	IconMaintenance,
	IconNewTab,
	IconRewind,
	IconRideInterconnection,
	IconSwitch,
} from '@flixbus/honeycomb-icons-react';
import { Text } from '@flixbus/honeycomb-react';

import styles from './AssignmentChip.module.css';

const BREAKDOWN_REASONS = {
	busFailure: {
		type: 'warning',
		name: 'Bus failure',
		icon: <IconMaintenance width={24} height={24} />,
	},
	driverFatigue: {
		type: 'warning',
		name: 'Driver fatigue',
		icon: <IconAccountAttention width={24} height={24} />,
	},
	driverOutOfHours: {
		type: 'warning',
		name: 'Driver out of hours',
		icon: <IconRewind width={24} height={24} />,
	},
	deadhead: {
		type: 'info',
		name: 'Deadhead:',
		icon: <IconGhost width={24} height={24} />,
		linkable: true,
	},
	parallelRide: {
		type: 'info',
		name: 'Parallel ride:',
		icon: <IconRideInterconnection width={24} height={24} />,
		linkable: true,
	},
	replacementCrewMember: {
		type: 'info',
		name: '',
		icon: <IconSwitch width={24} height={24} />,
		linkable: true,
	},
	other: { type: 'info', name: '', icon: <IconSwitch width={24} height={24} />, linkable: true },
};

/**
 * @typedef {Object} AssignmentChipProps
 * @property {keyof typeof BREAKDOWN_REASONS} breakdownReason
 * @property {import('react').ReactNode} [children]
 *
 * @param {AssignmentChipProps} props
 */
const AssignmentChip = ({ breakdownReason, children, linkTo }) => {
	const details = BREAKDOWN_REASONS[breakdownReason];

	return (
		<div className={cx(styles.container, styles[details?.type])}>
			{details?.icon && <span data-testid="chip-icon">{details.icon}</span>}

			<Text extraClasses={styles.name}>{details?.name}</Text>

			{children && (
				<div className={styles.details}>
					<Text extraClasses={styles.children}>{children}</Text>
					{details?.linkable && linkTo && (
						<Link
							target="_blank"
							rel="noopener noreferrer"
							aria-label={`View ${details.name.replace(':', '')} details`}
							to={linkTo}
						>
							<IconNewTab width={20} height={20} />
						</Link>
					)}
				</div>
			)}
		</div>
	);
};

export default AssignmentChip;
